// ===================================================================
// CONSTANTS — colours only; user-facing labels live in i18n (icb.* namespace)
// ===================================================================
export const RATING = {
  VERY_STRONG: { bg: '#bbf7d0', color: '#15803d' },
  STRONG:      { bg: '#dcfce7', color: '#16a34a' },
  NEUTRAL:     { bg: '#fef3c7', color: '#d97706' },
  WEAK:        { bg: '#fee2e2', color: '#dc2626' },
  VERY_WEAK:   { bg: '#fecaca', color: '#991b1b' },
};

export const SAT = {
  LOW:      { bg: '#dcfce7', color: '#16a34a', icon: 'CheckCircle' },
  MODERATE: { bg: '#fef3c7', color: '#d97706', icon: 'RemoveCircle' },
  HIGH:     { bg: '#fed7aa', color: '#ea580c', icon: 'Warning' },
  EXTREME:  { bg: '#fee2e2', color: '#dc2626', icon: 'Warning' },
};

export const REC = {
  ACCUMULATE: { color: '#16a34a', bg: '#dcfce7' },
  SELECTIVE:  { color: '#d97706', bg: '#fef3c7' },
  CAUTION:    { color: '#ea580c', bg: '#fed7aa' },
  AVOID:      { color: '#dc2626', bg: '#fee2e2' },
};

export const Q_STYLE = {
  BUY:         { color: '#16a34a' },
  EARLY_ENTRY: { color: '#2563eb' },
  MONITOR:     { color: '#d97706' },
  AVOID:       { color: '#dc2626' },
};

export const TIER_STYLE = {
  LEADER:   { bg: '#dcfce7', color: '#15803d' },
  EMERGING: { bg: '#dbeafe', color: '#1d4ed8' },
  WATCH:    { bg: '#fef3c7', color: '#a16207' },
  REST:     { bg: '#f1f5f9', color: '#64748b' },
};

// ===================================================================
// PURE HELPERS
// ===================================================================
export const scoreColor = (s) => {
  if (s >= 65) return '#10b981';
  if (s >= 50) return '#f59e0b';
  if (s >= 35) return '#f97316';
  return '#ef4444';
};

export const flowColor = (s) => {
  if (s >= 70) return '#10b981';
  if (s >= 40) return '#3b82f6';
  if (s >= 20) return '#f59e0b';
  return '#ef4444';
};

export const fmt = (v, d = 1) => (v != null ? Number(v).toFixed(d) : '-');

export const fmtPct = (v, d = 2) => {
  if (v == null) return '-';
  return `${v >= 0 ? '+' : ''}${Number(v).toFixed(d)}%`;
};

export const fmtCap = (v) => {
  if (!v) return '-';
  return v >= 1000 ? `${(v / 1000).toFixed(1)}T` : `${Number(v).toFixed(0)}B`;
};

export const scoreLabel = (v) => {
  if (v == null) return { key: null, text: '-', color: '#94a3b8' };
  if (v >= 75) return { key: 'icb.scoreLabel.veryStrong', color: '#15803d' };
  if (v >= 60) return { key: 'icb.scoreLabel.strong',     color: '#10b981' };
  if (v >= 45) return { key: 'icb.scoreLabel.good',       color: '#3b82f6' };
  if (v >= 30) return { key: 'icb.scoreLabel.average',    color: '#f59e0b' };
  return { key: 'icb.scoreLabel.weak', color: '#ef4444' };
};
